<div
  class="tap-alert px-3.5"
  [ngClass]="['tap-alert--' + type, compact ? 'py-1.5' : 'mb-2.5 py-2.5']"
  role="alert"
  aria-live="polite"
>
  <div class="tap-alert__header">
    <mat-icon class="tap-alert__icon">{{ iconName }}</mat-icon>
    <span *ngIf="title" class="tap-alert__title">{{ title | translate }}</span>
    <!-- Compact: the message and any projected action share the icon's line. -->
    <span *ngIf="compact" class="flex flex-wrap items-center gap-x-2 font-normal">
      <ng-container *ngIf="message">{{ message | translate: messageParams }}</ng-container>
      <ng-container *ngTemplateOutlet="projected"></ng-container>
    </span>
    <span class="tap-alert__spacer"></span>
    <button
      *ngIf="dismissible"
      mat-icon-button
      class="tap-alert__dismiss"
      (click)="onDismiss()"
      aria-label="Dismiss"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <ng-container *ngIf="!compact">
    <p *ngIf="message" class="tap-alert__message">{{ message | translate: messageParams }}</p>
    <ul *ngIf="items?.length" class="tap-alert__list">
      <li *ngFor="let item of items">{{ item | translate }}</li>
    </ul>
    <ul *ngIf="linkedItems?.length" class="tap-alert__list">
      <li *ngFor="let item of linkedItems">
        <button *ngIf="item.fieldId; else plainText" class="tap-alert__field-link" (click)="onItemClick(item.fieldId)">
          {{ item.messageKey | translate: item.translationParams }}
        </button>
        <ng-template #plainText>{{ item.messageKey | translate: item.translationParams }}</ng-template>
      </li>
    </ul>
    <ng-container *ngTemplateOutlet="projected"></ng-container>
  </ng-container>
</div>

<!-- Content can only be projected once, so it is captured here and stamped wherever the layout wants it. -->
<ng-template #projected><ng-content></ng-content></ng-template>
